/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { TextInput, View } from "react-native";
import { Text, styles } from "UpduoLibrary";
import { skaleWebTextLightGray } from "config/UpduoColors";

interface SignupFormProps {
  firstName?: string;
  lastName?: string;
  email?: string;
  emailValid?: boolean;
  showEmailValidationText?: boolean;
  emailValidationText?: string;
  password?: string;
  passwordValid?: boolean;
  passwordValidationText?: string;
  passwordServerValid?: boolean;
  startObject?: any;
  onChangeTextFirstName?: (text: string) => void;
  onKeyPressFirstName?: (e: any) => void;
  onChangeTextLastName?: (text: string) => void;
  onKeyPressLastName?: (e: any) => void;
  onChangeTextEmail?: (text: string) => void;
  onKeyPressEmail?: (e: any) => void;
  onChangeTextPassword?: (text: string) => void;
  onKeyPressPassword?: (e: any) => void;
}

export default function SignupForm({
  firstName,
  lastName,
  email,
  emailValid,
  showEmailValidationText,
  emailValidationText,
  password,
  passwordValid,
  passwordValidationText,
  passwordServerValid,
  startObject,
  onChangeTextFirstName,
  onKeyPressFirstName,
  onChangeTextLastName,
  onKeyPressLastName,
  onChangeTextEmail,
  onKeyPressEmail,
  onChangeTextPassword,
  onKeyPressPassword,
}: SignupFormProps) {
  const [emailAttempted, setEmailAttempted] = useState(false);
  const [passwordAttempted, setPasswordAttempted] = useState(false);

  const variableTextInputStyle =
    startObject.orgJoinRule === "E"
      ? [styles.textInput, { color: skaleWebTextLightGray }]
      : styles.textInput;
  return (
    <View>
      <Text isHeading={true} style={styles.routeHeading}>
        {"Sign Up"}
      </Text>
      <Text style={styles.textInputHeader}>{"First Name"}</Text>
      <TextInput
        value={firstName}
        onChangeText={onChangeTextFirstName}
        autoCapitalize={"none"}
        autoCorrect={false}
        style={variableTextInputStyle}
        autoFocus={true}
        onKeyPress={onKeyPressFirstName}
        editable={!(startObject.orgJoinRule === "E" && firstName)}
      />
      <Text style={styles.textInputHeader}>{"Last Name"}</Text>
      <TextInput
        value={lastName}
        onChangeText={onChangeTextLastName}
        autoCapitalize={"none"}
        autoCorrect={false}
        style={variableTextInputStyle}
        autoFocus={true}
        onKeyPress={onKeyPressLastName}
        editable={!(startObject.orgJoinRule === "E" && lastName)}
      />
      <Text style={styles.textInputHeader}>{"Email Address"}</Text>
      <TextInput
        value={email}
        onChangeText={onChangeTextEmail}
        autoCapitalize={"none"}
        autoCorrect={false}
        style={variableTextInputStyle}
        onKeyPress={onKeyPressEmail}
        onBlur={() => setEmailAttempted(true)}
        editable={!(startObject.orgJoinRule === "E" && email)}
      />
      {emailAttempted && !emailValid ? (
        <Text style={styles.warningText}>
          {"Please enter a valid email address."}
        </Text>
      ) : null}
      {emailValidationText && showEmailValidationText ? (
        <Text style={styles.warningText}>{emailValidationText}</Text>
      ) : null}
      <Text style={styles.textInputHeader}>{"Password (10+ characters)"}</Text>
      <TextInput
        value={password}
        onChangeText={onChangeTextPassword}
        secureTextEntry={true}
        autoCapitalize={"none"}
        style={styles.textInput}
        onKeyPress={onKeyPressPassword}
        onBlur={() => setPasswordAttempted(true)}
      />
      {passwordAttempted && !passwordValid ? (
        <Text style={styles.warningText}>
          {"Password must be at least 10 characters."}
        </Text>
      ) : null}
      {!passwordServerValid ? (
        <Text style={styles.warningText}>{passwordValidationText}</Text>
      ) : null}
    </View>
  );
}
